import { useTable } from "./useTable";

export const TypeFirstTimeImport = ({
  form,
  remove,
  handleRemoveProduct,
  tags,
  handleGetTags,
  sumSerialByLack,
  sumSerialByOrder,
  sumSerialByScanned,
  handleClearAllSerials,
}) => {
  const { columns } = useTable({
    form,
    remove,
    handleRemoveProduct,
    tags,
    handleGetTags,
    sumSerialByLack,
    sumSerialByOrder,
    sumSerialByScanned,
    handleClearAllSerials,
  });
  return { columns };
};
